var exports = {
  "container": "x9997bc76--4c2e6b--container",
  "image": "x9997bc76--4c2e6b--image",
  "search": "x9997bc76--4c2e6b--search",
  "recommendations": "x9997bc76--4c2e6b--recommendations",
  "updates": "x9997bc76--4c2e6b--updates",
  "comparison": "x9997bc76--4c2e6b--comparison",
  "selection": "x9997bc76--4c2e6b--selection",
  "title": "x9997bc76--4c2e6b--title",
  "subtitle": "x9997bc76--4c2e6b--subtitle",
};

module.exports = exports;
